<swb-modal #modal="modal">
  <div modal-header><em>{{ getTitle(calendar) }}</em>, {{ day | date:'d. M. yyyy' }} od {{ from }}
  </div>
  <div modal-body>
    <div class="modal__confirmation"
         *ngIf="showConfirmation">
      <ng-container *ngIf="toCancelId">
        <label for="cancelled_reason">Opravdu chcete zrušit tuto rezervaci?</label>
        <textarea [(ngModel)]="cancelled_reason"
                  name="cancelled_reason"
                  style="height: 100px"
                  placeholder="Důvod zrušení"></textarea>
      </ng-container>
      <ng-container *ngIf="toReactivateId">
        <label>Opravdu chcete znovu aktivovat tuto rezervaci?</label>
      </ng-container>
    </div>
    <div *ngIf="!showConfirmation">
      <div class="loading loading--dark"
           *ngIf="!isInitialized"></div>
      <div *ngIf="isInitialized">
        <div *ngIf="calendar.appointment_calendar_bookings.length > 0">
          <h3>Rezervace v tomto časovém okně</h3>
          <ul class="widget__list">
            <li *ngFor="let booking of calendar.appointment_calendar_bookings"
                class="widget__list__item">
              <span class="widget__list__title"
                    [ngStyle]="{ 'opacity': booking.cancelled ? .4 : 1 }">
                <ng-container *ngIf="booking.cancelled">(Zrušeno) </ng-container>
                <ng-container *ngIf="booking.manual">
                  Manuálně zablokováno
                </ng-container>
                <ng-container *ngIf="!booking.manual">
                  <strong>{{ booking.datetime_from | date:'HH:mm' }} -
                    {{ booking.datetime_to | date:'HH:mm' }} - <span
                          *ngFor="let record of generateArray(booking.formrecord.content); let i = index">
                      <ng-container *ngIf="i > 1">{{ record.value }} </ng-container>
                    </span></strong>
                </ng-container>
              </span>
              <span class="widget__list__actions">
                <a *ngIf="!booking.cancelled"
                   (click)="prepareCancel(booking.id)"
                   class="widget__list__actions__link widget__list__actions__link--remove">
                  <i class="ico-remove"></i>
                </a>
                <a *ngIf="booking.cancelled"
                   (click)="prepareReactivate(booking.id)"
                   class="widget__list__actions__link">
                  <i class="ico-success"></i>
                </a>
              </span>
            </li>
          </ul>
        </div>
        <swb-no-data *ngIf="calendar.appointment_calendar_bookings.length == 0"
                     text="V tomto okně zatím nejsou žádné rezervace."></swb-no-data>
        <p *ngIf="activeBookings.length < calendar.slot_capacity">
          <button class="cta cta--small cta--red"
                  (click)="blockWindow()">Blokovat termín</button>
        </p>
      </div>
    </div>
  </div>
  <div modal-footer>
    <ng-container *ngIf="showConfirmation">
      <button class="cta cta--red"
              (click)="resetConfirmation()">Ne</button>
      <button class="cta cta--green"
              (click)="toggleBooking()">Ano</button>
    </ng-container>
  </div>
</swb-modal>